<template>
  <el-card>
    <el-form v-loading="loading" ref="ruleForm" :rules="rules" :model="form" label-width="100px">
      <el-form-item  label="管理员邮箱" style="width: 600px;" prop="email">
        <el-input v-model="form.email" placeholder="请输入管理员邮箱"></el-input>
        <div style="color: #c1c1c1;">添加成功后邮箱即登录账号，账号初始密码邮件发送至管理员邮箱</div>
      </el-form-item>

      <el-form-item  label="管理员昵称" style="width: 600px;" prop="name">
        <el-input v-model="form.name" placeholder="请输入管理员昵称"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSubmit">提交</el-button>
      </el-form-item>
    </el-form>

  </el-card>
</template>

<script>
  import _ from 'lodash'
  import store from '@/store'
  import { createNamespacedHelpers } from 'vuex'

  export default {
    data() {
      return {
        loading: false,
        form: {
          name: '',
          email: '',
        },
        rules: {
          name : [{ required: true, message: '请输入管理员昵称', trigger: 'blur' }],
          email : [
            {required: true, message: '请输入邮箱地址', trigger: 'blur' },
            {type: 'email', required: true, message: '请输入正确邮箱格式', trigger: 'blur' },
          ],
        }
      }
    },
    methods: {
      async onSubmit() {
        try {
          await new Promise((resovle, reject) => {
            this.$refs['ruleForm'].validate((valid) => {
              valid ? resovle(true) : reject(false)
            })
          });
        } catch (error) {
          return false;
        }

        try {
          await this.$store.dispatch('admins/create', this.form)
          this.$message.success('管理员添加成功，初始密码已发送至账号邮箱请注意邮件通知');
          this.$router.push({path: '/admin/list'})
        } catch (error) {
          this.$message.error(error.response.data.message);
        }
      },
    },
    mounted() {

    }
  }
</script>
